import styled, { css } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 200;
  width: 100%;
  height: 100%;
  padding: 25px 0;
  overflow: auto;
  background-color: rgba(0,0,0,0.5);

  ${props =>
    !props.desktop &&
    !props.isIOSApp &&
    css`
    position: fixed;
    bottom: 0px;
    height: auto;
    padding: 0px;
  `}

  ${props =>
    !props.desktop &&
    props.isIOSApp &&
    css`
    position: absolute;
    top: 0px;
    bottom: 0px;
    height: auto;
    padding: 0px;
  `}

  ${props =>
  !props.desktop &&
  props.isAndroidApp &&
  css`
    position: absolute;
    top: 0px;
    bottom: 0px;
    height: auto;
    padding: 0px;
  `}
`;

export const Popup = styled.div`
  position: relative;
  display: table;
  width: 100%;
  max-width: 940px;
  height: 100%;
  margin: 0 auto;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;

  ${props =>
    !props.desktop &&
    css`
    position: relative;
    display: table;
    min-height: 100%;
    border-radius: 0px;
    box-shadow: none;
  `}
`;

export const PopupTableCell = styled.div`
  position: relative;
  display: table-cell;
  vertical-align: middle;

  ${props =>
    !props.desktop &&
    css`
    display: table-cell;
    padding: 0px;
  `}
`;

export const PopupInner = styled.div`
  text-align: left;
  position: relative;
  width: 100%;
  padding: 30px 29px 38px;
  background: #f6f6f6;
  border-radius: 5px;
  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);
  overflow-x: hidden;

  ${props =>
    !props.desktop &&
    css`
    position: relative;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 25px;
    background: #f6f6f6;
    border-radius: 0px;
    box-shadow: none;
    webkit-transform: translateZ(0px);
    @media (max-width: 414px) {
      padding: 20px;
      padding-bottom: 30px;
    }
    @media (max-width: 360px) {
      padding: 17px;
      padding-bottom: 27px;
    }
    @media (max-width: 320px) {
      padding: 15px;
      padding-bottom: 25px;
    }
  `}


  ${props =>
    !props.desktop &&
    !props.isIOSApp &&
    css`
      padding-top: 100px;

      @media (max-width: 800px) {
        padding-top: 50px;
      }
  `}
`;

export const Close = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 16px;
  height: 16px;
  background-size: cover;
  cursor: pointer;
  :before {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
    width: 0px;
    height: 20px;
    border-left: 2px solid #a0a7b2;
    transition: all 0.3s ease;
  }
  :after {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0%;
    width: 0px;
    height: 20px;
    border-left: 2px solid #a0a7b2;
    transition: all 0.3s ease;
  }
  :hover {
    :before {
      border-left-color: #60a31c;
    }
    :after {
      border-left-color: #60a31c;
    }
  }
`;

export const Header = styled.h2`
  margin: 0px;
  margin-bottom: 6px;
  padding: 0px;
  font-weight: 300;
  font-size: 30px;
  line-height: 1;
  color: #a5a4a4;
  text-align: center;

  ${props =>
    !props.desktop &&
    css`
    margin: 0px;
    font-weight: 400;
    font-size: 24px;
    color: #a5a4a4;
    text-align: center;
    @media (max-width: 480px) {
      font-size: 22px;
    }
  `}
`;

export const SectionView = styled.section`
  margin-top: 22px;
  border-bottom: 0px;
  :first-of-type {
    margin-top: 35px;
  }
  :nth-of-type(n+2) {
    padding-bottom: 20px;
  }
  @media (max-width: 959px) {
    margin-top: 0px;
    border-bottom-color: #f6f6f6;
    padding-bottom: 10px;
  }

  ${props =>
    !props.desktop &&
    css`
    margin: 0 auto;
    margin-top: 15px;
    :first-of-type {
      margin-top: 15px;
    }
    :nth-of-type(2) {
      margin-top: 15px;
      @media (max-width: 959px) {
        margin-top: 20px;
      }
    }
    @media (max-width: 414px) {
      max-width: 100%;
    }
    @media (max-width: 480px) {
      max-width: 290px;
    }
    @media (max-width: 640px) {
      max-width: 388px;
    }
    @media (max-width: 736px) {
      max-width: 446px;
    }
  `}
`;

export const RowContainerView = styled.div`
  direction: ${props => props.theme.direction};
  margin-bottom: 24px;

  ${props => props.theme.direction === "rtl" && css`
    text-align: right;
  `};

  :last-of-type {
    margin-bottom: 0;
  }
  @media(max-width: 959px) {
    margin-bottom: 15px;
  }

  ${props =>
    props.inlineRow &&
    !props.desktop &&
    css`
    display: inline-block;
    vertical-align: top;
    margin-bottom: 0px;
    :nth-of-type(odd) {
      width: 56.5%;
      padding-right: 8px;
    }
    :nth-of-type(even) {
      width: 43.5%;
      padding-left: 8px;
    }
    @media(max-width: 959px) {
      margin-bottom: 0px;
      vertical-align: bottom;
    }
  `}
`;

export const MainView = styled.div`
  width: 100%;
  margin-right: 0;

  ${props =>
    props.desktop &&
    css`
    display: inline-block;
    vertical-align: top;
    width: 460px;
    margin-right: 20px;

    ${props => props.theme.direction === "rtl" && css`
      margin-right: 0;
      margin-left: 20px;
    `};
  `}
`;

export const InputItemView = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 220px;
  min-height: 39px;
  font-weight: 400;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 39px;
  color: #a5a4a4;
  ${props => props.theme.direction === "rtl" && css`
    text-align: right;
  `};
  :first-of-type {
    margin-right: 20px;
    margin-bottom: 4px;

    ${props => props.theme.direction === "rtl" && css`
      margin-right: 0;
      margin-left: 20px;
    `};
  }
  ${props =>
    !props.desktop &&
    css`
    width: 100%;
    min-height: 0px;
    line-height: 1;
    :first-of-type {
      margin-right: 0;
      ${props => props.theme.direction === "rtl" && css`
        margin-left: 0;
      `};
    }
  `};
`;

export const InputItem1 = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 140px;
  margin-right: 20px;
  line-height: 38px;
  :nth-of-type(3) {
    margin-right: 0px;
  }

  ${props =>
    !props.desktop &&
    css`
    width: 100%;
    min-height: 0px;
    line-height: 1;
  `}
`;

export const ButtonContainer = styled.div`
  max-width: 266px;
  margin: 20px auto 0;
  text-align: center;

  ${props =>
    !props.desktop &&
    css`
    display: inline-block;
    vertical-align: middle;
    width: 50%;
    :first-of-type {
      padding-right: 6px;
    }
    :last-of-type {
      padding-left: 6px;
    }
  `}
`;

export const ButtonWrapper = styled(SectionView)`
  text-align: center;
  padding-bottom: 0px;
  :last-of-type {
    padding-bottom: 0px;
  }
`;

export const HelpTextView = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  font-weight: 400;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 19px;
  color: #a5a4a4;
  @media (max-width: 959px) {
    line-height: 1.25;
  }
  @media (max-width: 480px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  }
`;

export const BonusHeader = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 80px;
`;

export const BonusSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 140px;

  ${props =>
    !props.desktop &&
    css`
    width: 100%;
    padding: 12px 0;
  `}
`;

export const Label = styled.span`
  direction: ${props => props.theme.direction};
  display: block;
  width: 100%;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  color: #797979;
  text-align: center;
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const ScanItemContainer = styled.div`
  ${props =>
    !props.desktop &&
    css`
    max-width: 180px;
    margin: 4px auto 12px;
  `}
`;

export const ScanItemInfo = styled.div`
  ${props =>
    !props.desktop &&
    css`
    max-width: 220px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  `}
`;

export const KdongAmount = styled.span`
  color: #4e2a81;
  font-size: 16px;
  margin-left: 7px;

  ${props =>
    !props.desktop &&
    css`
    margin-left: 0px;
  `}
`;

export const KdongKdong = styled.span`
  font-size: 16px;
  color: #717171;
`;

export const KdongInfo = styled.span`
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};

  ${props =>
    !props.desktop &&
    css`
    margin-left: 5px;
    white-space: nowrap;
    line-height: 2;
  `}
`;

export const KdongContainer = styled.div`
  max-width: 180px;
  margin: 4px auto 12px;
  text-align: center;

  ${props =>
    !props.desktop &&
    css`
    max-width: 90%;
  `}
`;


// WEBPACK FOOTER //
// ./src/components/OfflinePopup/StyledComponents.js